export default __webpack_public_path__ + "static/media/Roboto-Black.2a428584.ttf";